import {accessRulesParsing} from '@/helpers/accessRules'
import {Application} from '@/types/Applications'

export const getApplicationsWithAccess = (applications: Application[]) => {
  const [allowedApplications, allowedCountries] = accessRulesParsing()

  return applications
    .filter(application => !allowedApplications || allowedApplications.includes(application.code))
    .map(application => ({
      ...application,
      countries: allowedCountries
        ? application.countries.filter(country => allowedCountries.includes(country.code))
        : application.countries,
    }))
}
